import { useEffect, useState } from 'react';

// Phone breakpoint for the responsive fold. Below this width the shell drops
// the environment tabs + iframe entirely and renders only the chat panel —
// /AltY becomes the mobile Alt-Y experience on one bundle. The value matches
// the existing 820px topbar collapse breakpoint in styles.css.
export const MOBILE_BREAKPOINT = 820;

function query() {
  return `(max-width: ${MOBILE_BREAKPOINT}px)`;
}

// True when the viewport is at/below the phone breakpoint. Re-evaluates on
// resize + orientation change via matchMedia so a desktop→phone rotation
// (or a devtools viewport switch) flips the layout live.
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(query()).matches
      : false,
  );

  useEffect(() => {
    if (!window.matchMedia) return;
    const mql = window.matchMedia(query());
    const onChange = () => setIsMobile(mql.matches);
    onChange();
    // addEventListener('change') is the modern API; older Safari needs the
    // deprecated addListener fallback.
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  return isMobile;
}
